var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M452.56,506.021,374.885,640.559a5.875,5.875,0,0,0,5.088,8.814H535.328a5.876,5.876,0,0,0,5.088-8.814L462.738,506.021A5.876,5.876,0,0,0,452.56,506.021Z",
    transform: "translate(-374.088 -503.082)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(-9918 24359)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(9918 -24359)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(9565.554 -24828.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(391.231 504.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M488.821,660.39s-12.526-5.962-21.251-22.325c-4-7.494-21.26-18.3-30.9-29.306-11.313-12.914,1.031-23.15-11.339-42.154-11.432-17.559-21.894-15.634-26.234-29.776-3.588-11.7,4.022-35.043,4.022-35.043l12.5,3.043,43.8,61.462L474.561,597.4l15.431,37.8s8.716,13.633,8.7,14.924-3.637,12.448-3.637,12.448Z",
    transform: "translate(-328.511 -505.539)",
    fill: "#e2e5ec"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M460.851,565.437H367.94a2.9,2.9,0,1,1,0-5.791h92.911a2.9,2.9,0,0,1,0,5.791Z",
    transform: "translate(0 109.121)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M453.333,565.437H406.879a2.9,2.9,0,1,1,0-5.791h46.454a2.9,2.9,0,1,1,0,5.791Z",
    transform: "translate(73.813 109.121)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M473.8,565.437H427.341a2.9,2.9,0,1,1,0-5.791H473.8a2.9,2.9,0,0,1,0,5.791Z",
    transform: "translate(112.601 109.121)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M537.226,654.167H381.873a8.771,8.771,0,0,1-7.6-13.155l77.678-134.541a8.768,8.768,0,0,1,15.193,0l77.681,134.541a8.771,8.771,0,0,1-7.6,13.155ZM459.551,507.872a2.931,2.931,0,0,0-2.58,1.494L379.293,643.908a2.978,2.978,0,0,0,2.58,4.468H537.226a2.978,2.978,0,0,0,2.583-4.468L462.131,509.366A2.934,2.934,0,0,0,459.551,507.872Z",
    transform: "translate(15.243 0)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(462.916 542.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M413.615,607.1h-5.936a8.8,8.8,0,0,1-8.835-8.835v-5.09a9.142,9.142,0,0,1,2.67-6.3,8.629,8.629,0,0,1,6.3-2.67h5.655a8.841,8.841,0,0,1,6.3,2.592,8.591,8.591,0,0,1,2.676,6.243v5.229a8.814,8.814,0,0,1-8.835,8.835ZM407.817,590a2.835,2.835,0,0,0-2.169.93,3.28,3.28,0,0,0-1.013,2.334v5.009a3.011,3.011,0,0,0,3.043,3.043h5.936a3.021,3.021,0,0,0,3.043-3.043V593.04a2.781,2.781,0,0,0-.935-2.1,3.013,3.013,0,0,0-2.25-.938Zm3.04-10.108a8.539,8.539,0,0,1-6.388-2.681,9.272,9.272,0,0,1-2.58-5.985l-2.9-46.15a8.1,8.1,0,0,1,2.522-6.419,8.848,8.848,0,0,1,6.3-2.594h5.939a8.667,8.667,0,0,1,6.362,2.762,8.324,8.324,0,0,1,2.467,6.385v.009l-2.9,46.02a9.47,9.47,0,0,1-2.751,6.11A8.442,8.442,0,0,1,410.858,579.888Zm-3.04-58.04a3.015,3.015,0,0,0-2.253.941,2.3,2.3,0,0,0-.793,1.928l2.9,46.153a3.57,3.57,0,0,0,1.016,2.369,2.748,2.748,0,0,0,2.172.857,2.636,2.636,0,0,0,1.984-.849,3.7,3.7,0,0,0,1.071-2.435l2.893-45.959a2.52,2.52,0,0,0-.857-2.018,2.867,2.867,0,0,0-2.192-.987Z",
    transform: "translate(-398.844 -516.057)",
    fill: "#2f4265"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.081641abb9822242bc2f400fae66c921.svg";
export { ForwardRef as ReactComponent };